
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiUrl } from '../../../Network/ApiUrl';
import { get } from '../../../Network/ApiService';
import { RootState } from '../..';

interface FetchProviderProfileDataArgs {
    authToken: string;
    userId:string;
}

interface ProviderProfileData {
    userData: any;
}

// Create the Thunk action
export const fetchAllProviderProfileData = createAsyncThunk<ProviderProfileData, FetchProviderProfileDataArgs, { state: RootState }>(
    'profile/fetchAllProviderProfileData',
    async ({ userId,authToken }, { dispatch }) => {

        try {

            // Use the API with userId
            const  ApiEndPoint = `${ApiUrl.user_profile.get_all_provider_profile}?adminId=${userId}`;

            const response = await get(ApiEndPoint, authToken) || []

            if (response) {
                return response.data ? response.data : response; // This value will be the payload of the fulfilled action
            } else {
                throw new Error('Failed to fetch Provider profile data');
            }
        } catch (error) {
            console.log("🚀 ~ error:", error, error)

            throw error; // This will trigger the rejected action
        }
    }
);
